module.exports = __webpack_public_path__ + "img/chaine-du-froid.d3ac0592.jpeg";